
import { ref } from 'vue'
import NavigationItemWrapper from './components/iterables/NavigationItemWrapper.vue'
import HttpClient from './services/HttpClient'
const HTTP = new HttpClient('')

export default {
  components: {
    NavigationItemWrapper
  },
  setup() {
    const drawer = ref(false)

    const getWholesaler = () => {
      console.log('test')
    }

    const routes = [
      // {
      //   path: '/',
      //   text: 'Go Wireless',
      //   icon: 'wifi'
      // },
      // {
      //   path: '/mobile-voice',
      //   text: 'Mobile Voice',
      //   icon: 'phonelink_ring'
      // },
      {
        path: '/',
        text: 'Service List',
        icon: 'search'
      },
      {
        path: '/orders-list',
        text: 'Orders List',
        icon: 'format_list_numbered'
      },
      {
        path: '/activate',
        text: 'Activate',
        icon: 'flip_camera_android'
      },
      {
        path: '/port-out',
        text: 'Port Out',
        icon: 'assignment'
      },
      {
        path: '/port-in',
        text: 'Port In',
        icon: 'fact_check'
      },
      {
        path: '/drop-ship',
        text: 'Drop Ship',
        icon: 'local_shipping'
      },
      {
        path: '/coverage',
        text: 'Coverage',
        icon: 'travel_explore'
      },
      {
        text: 'Admin',
        icon: 'admin_panel_settings',
        children: [
          {
            path: '/admin/clients',
            text: 'Clients',
            icon: 'group'
          },
          {
            path: '/admin/bearer',
            text: 'Bearer',
            icon: 'person'
          },
          {
            path: '/admin/go-wireless',
            text: 'GoWireless',
            icon: 'cell_wifi'
          },
          {
            path: '/admin/inventory',
            text: 'Inventory',
            icon: 'inventory_2'
          }
        ]
      }
    ]

    const toggleDrawer = () => {
      drawer.value = !drawer.value
    }

    return {
      drawer,
      routes,
      toggleDrawer,
      getWholesaler
    }
  }
}
